import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState, useMemo} from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import PopUp from '../../Shared/Popup/PopUp';
import PopUpWithAnimation from '../../Shared/PopUpWithAnimation/PopUpWithAnimation';
import OtpExtendedPopup from '../../Block/SelfcareExtendedOtpButtonBlock/PopUp/OtpExtendedPopup';
//---------------PAGES---------------
import SubscribersPage from './pages/SubscribersPage/SubscribersPage';
import ErrorPage from './pages/ErrorPage/ErrorPage';
import SuccessPage from './pages/SuccessPage/SuccessPage';
import StepPage from './pages/StepPage/StepPage';
import CallBackPage from './pages/CallBackPage/CallBackPage';
import LoaderPage from './pages/LoaderPage/LoaderPage';
//---------------ENUMS---------------
import ErrorsEnum from './constant/ErrorsEnum';
import StepsEnum from './constant/StepsEnum';
import PageEnum from './constant/PageEnum';

import BtnWhiteBlackBorderBigSize from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {
  initBlock,
  resetBlock,
  setSubscriber,
  goToPage,
  reportDWH,
  setIsShowPopup,
  setIsShowExtendedOtpPopup,
} from './LocalCellularTroubleshootingWizardBlockSlice';
import {goToPageAsync, onClickPopupButton} from './LocalCellularTroubleshootingWizardBlockThunk';
import arrow from './images/arrow.svg';
import Config from '../../../Config';

const LocalCellularTroubleshootingWizardBlock = (props) => {
  useEffect(() => {
    props.initBlock({epiBlockData: props.iContent});
    props.goToPageAsync({pageType: PageEnum.SUBSCRIBERS});
    return () => {
      props.resetBlock();
    };
  }, []);

  const initWizard = async () => {};

  //   useEffect(() => {
  //     props.setSubscriber(props.selfCareSubscriber);
  //     initWizard();
  //   }, [props.selfCareSubscriber]);

  const handleOnClickBackBtn = () => {
    window.history.back();
  };

  const handleOnClickPopupButton = () => {
    props.onClickPopupButton();
  };

  const onClosePopup = () => {
    props.setIsShowPopup(false);
  };

  const onCloseExtendedOtpPopup = () => {
    props.setIsShowExtendedOtpPopup(false);
  };

  const handleOnOtpExtendedFinished = () => {
    props.setIsShowExtendedOtpPopup(false);
    props.goToPageAsync({pageType: StepsEnum.OPEN_OUTGOING_CALLS_MABAL});
  };

  const currentPage = useMemo(() => {
    switch (props.page) {
      case PageEnum.SUBSCRIBERS:
        return <SubscribersPage />;
      case PageEnum.ERROR:
        return <ErrorPage context={props.context}/>;
      case PageEnum.STEP:
        return <StepPage context={props.context}/>;
      case PageEnum.CALLBACK:
        return <CallBackPage />;
      case PageEnum.LOADER:
        return <LoaderPage />;
      case PageEnum.SUCCESS:
        return <SuccessPage />;
      default:
        return null;
    }
  }, [props.page]);

  return (
    <div className='local-cellular-troubleshooting-wizard-block'>
      {/* <div className='wrapper-back-button'>
        <a href='#' className='button' onClick={handleOnClickBackBtn}><img src={arrow} alt='icon'></img> חזרה</a>
      </div> */}
      <div className={`page-wrapper ${props.page == PageEnum.LOADER ? 'full-width' : ''}`}>{currentPage}</div>
      <PopUp showPopUp={props.isShowPopup} onClose={() => onClosePopup()} className="local-cellular-troubleshooting-wizard-popup">
      {props.pageContent.popup?.icon && <Image className='icon' src={props.pageContent.popup.icon} alt={''} /> }
      {props.pageContent.popup?.title && <h1>{props.pageContent.popup.title}</h1> }
      {props.pageContent.popup?.text && <div className='text' dangerouslySetInnerHTML={{__html: props.pageContent.popup.text}}></div> }
      <BtnWhiteBlackBorderBigSize text={props.pageContent.popup?.buttonText} onclick={() => {handleOnClickPopupButton();}}/>
    </PopUp>
    <PopUpWithAnimation className='localCellularTroubleshootingWizardExtendedOtpPopUp' isShow={props.isShowExtendedOtpPopup} onClose={onCloseExtendedOtpPopup}>
        <OtpExtendedPopup setShowPopUp={onCloseExtendedOtpPopup} showPopup={props.isShowExtendedOtpPopup} setOtpExtendedFinished={handleOnOtpExtendedFinished} title={'כדי להמשיך צריך אישור מבעל החשבון'} subTitle={'לחצו כאן ונשלח לו קוד חד פעמי שאיתו תוכלו להמשיך'} />
    </PopUpWithAnimation>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.localCellularTroubleshootingWizardBlock.page,
    pageContent: state.localCellularTroubleshootingWizardBlock.pageContent,
    isShowPopup: state.localCellularTroubleshootingWizardBlock.isShowPopup,
    isShowExtendedOtpPopup: state.localCellularTroubleshootingWizardBlock.isShowExtendedOtpPopup,
    dwhWizardName: state.localCellularTroubleshootingWizardBlock.dwhWizardName,
    // selfCareSubscriber: state.selfcarePage.subscribersByProduct
  };
};

const mapDispatchToProps = {
  resetBlock,
  initBlock,
  goToPage,
  setSubscriber,
  reportDWH,
  goToPageAsync,
  setIsShowPopup,
  setIsShowExtendedOtpPopup,
  onClickPopupButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocalCellularTroubleshootingWizardBlock);
